import React from 'react'

export default function EmptyStateImage() {
  return (
    <svg
      width="361"
      height="380"
      viewBox="0 0 361 380"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M296.217 335.602H64.1661C38.8366 309.322 20.5857 274.235 11.6395 235.411C-14.8657 120.39 27.8727 87.4456 66.4256 92.9669C145.116 104.251 65.3751 52.4831 109.714 17.0619C148.576 -13.9889 224.206 -0.694526 243.799 41.0569C271.438 99.9477 352.571 71.3488 360.308 163.592C364.727 216.261 348.46 288.18 296.209 335.602H296.217Z"
        fill="#D4EDF4"
      />
      <path
        d="M267.611 61.1126C256.614 50.3369 247.701 34.3486 251.103 20.02C255.205 2.7306 276.774 5.5663 287.521 12.3386C301.837 21.3628 311.108 44.3987 305.247 62.2052C301.486 73.623 291.898 75.9249 282.568 71.7715C277.766 69.6364 272.48 65.8832 267.611 61.1042V61.1126Z"
        fill="#D4EDF4"
      />
      <path
        d="M71.6615 315.365C67.8262 294.865 63.7241 274.331 56.7956 254.564C49.8671 234.798 40.0037 215.707 25.6548 199.844C42.3299 239.777 59.1885 280.436 62.7403 323.205"
        fill="#6FB4C4"
      />
      <path
        d="M67.2343 323.787C62.5486 283.011 37.761 244.663 1.40918 221.969C28.9815 250.826 49.05 285.98 59.3886 323.528"
        fill="#6FB4C4"
      />
      <path
        d="M68.6432 313.961C55.153 286.931 29.8902 265.296 0 255.188C24.229 274.003 44.4976 297.306 59.2968 323.361"
        fill="#6FB4C4"
      />
      <path
        d="M68.585 316.226C54.1777 279.437 48.6416 239.595 52.5102 200.562C56.9708 240.879 63.6659 281.663 81.9168 318.394"
        fill="#9DD8E5"
      />
      <path
        d="M67.9681 302.803C57.2543 270.618 40.3124 240.267 18.2095 213.695C39.0784 247.323 55.0615 283.62 65.5835 321.268"
        fill="#9DD8E5"
      />
      <path
        d="M67.3094 309.128C59.372 295.984 51.3679 282.789 41.4796 270.871C31.5912 258.944 19.6685 248.252 5.37793 241.305C30.5074 264.566 50.2674 292.923 62.9071 323.865"
        fill="#9DD8E5"
      />
      <path
        d="M68.1931 317.949C54.4778 295.622 27.9559 280.743 0.533691 279.984C25.6381 288.25 47.6159 304.672 61.8398 325.798"
        fill="#9DD8E5"
      />
      <path
        d="M313.809 263.851C315.018 259.072 320.938 253.092 325.507 252.85C326.741 252.783 328.067 253.025 329.167 252.441C331.994 250.94 330.952 245.727 333.369 243.559C334.837 242.241 337.046 242.55 338.889 243.242C340.723 243.934 342.549 244.952 344.475 244.86C346.343 244.768 347.985 243.642 349.703 242.875C351.895 241.899 354.472 241.515 356.673 242.6C358.882 243.675 360.467 246.545 359.708 248.988C358.799 251.891 355.439 252.75 353.513 254.96C349.611 259.447 352.454 268.238 348.085 272.183C345.317 274.676 340.848 273.926 338.113 276.461C335.871 278.538 335.462 282.208 333.545 284.651C331.427 287.337 327.725 288.062 324.507 287.203C321.288 286.344 318.479 284.126 315.994 281.699C315.994 281.699 311.45 273.208 313.818 263.859L313.809 263.851Z"
        fill="#5BABBA"
      />
      <path
        d="M354.78 246.453C346.293 252.016 337.813 257.679 330.126 264.468C322.439 271.257 315.51 279.222 310.708 288.672"
        stroke="#9DD8E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M337.296 258.612C337.213 254.825 336.538 251.039 335.312 247.461"
        stroke="#9DD8E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M332.353 262.656C337.755 262.982 343.016 266.184 346.16 271.063"
        stroke="#9DD8E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M346.493 251.921C348.702 251.63 350.987 251.888 353.121 252.664"
        stroke="#9DD8E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M318.412 276.758C322.823 277.15 327.15 278.968 330.718 281.912"
        stroke="#9DD8E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M320.905 273.846C320.747 269.092 319.855 264.346 318.295 259.867"
        stroke="#9DD8E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M316.836 268.863C320.755 267.471 324.982 266.895 328.659 264.96C332.344 263.025 335.496 259.122 334.745 255.027C334.287 252.508 332.427 250.331 332.336 247.762C332.227 244.727 334.57 242.241 336.613 239.998C338.656 237.746 340.665 234.802 339.764 231.899C339.122 229.831 337.063 228.246 337.03 226.069C336.988 223.417 339.931 221.691 340.673 219.147C341.357 216.803 339.873 214.176 337.663 213.142C335.454 212.108 332.769 212.483 330.643 213.667C328.517 214.852 326.875 216.762 325.524 218.788C323.223 222.241 321.413 226.386 317.728 228.288C316.044 229.155 314.11 229.456 312.401 230.265C308.84 231.949 306.548 235.994 306.923 239.914C307.165 242.491 308.432 245.152 307.473 247.562C306.814 249.222 305.247 250.298 303.955 251.532C300.419 254.91 298.702 260.089 299.502 264.91C300.111 268.58 302.879 274.093 306.723 275.394C308.824 276.103 309.674 273.367 311.05 272.141C312.709 270.657 314.752 269.597 316.844 268.855L316.836 268.863Z"
        fill="#85C5D7"
      />
      <path
        d="M304.78 289.855C309.583 264.951 319.596 241.064 333.97 220.172"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M325.974 232.841C328.008 231.915 330.176 231.298 332.394 231.031"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M319.805 244.628C318.771 241.4 317.245 238.339 315.302 235.57"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M313.151 260.219C318.429 258.701 323.89 257.826 329.376 257.617"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M311.5 264.411C310.091 261.225 307.315 258.673 304.021 257.539"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M311.308 304.777C314.793 306.036 318.028 308.03 321.655 308.78C325.282 309.531 329.659 308.63 331.46 305.394C332.569 303.401 332.519 300.849 333.911 299.03C335.554 296.879 338.572 296.495 341.249 296.103C343.925 295.711 346.976 294.819 347.994 292.317C348.719 290.523 348.202 288.271 349.403 286.762C350.87 284.919 353.872 285.386 355.823 284.06C357.615 282.834 358.082 280.19 357.148 278.221C356.214 276.261 354.155 275.002 352.021 274.61C349.886 274.218 347.677 274.61 345.601 275.236C342.066 276.312 338.472 278.138 334.862 277.362C333.211 277.004 331.719 276.12 330.076 275.711C326.674 274.86 322.814 276.345 320.855 279.247C319.562 281.166 318.929 283.709 316.911 284.819C315.519 285.586 313.835 285.444 312.242 285.561C307.898 285.886 303.788 288.472 301.612 292.25C299.953 295.127 298.744 300.482 300.653 303.551C301.695 305.227 303.83 303.826 305.472 303.759C307.456 303.676 309.457 304.11 311.317 304.777H311.308Z"
        fill="#85C5D7"
      />
      <path
        d="M291.14 312.403C308.532 297.983 328.926 287.207 350.628 280.969"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M337.963 285.156C339.889 285.665 341.732 286.474 343.408 287.542"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M327.058 289.775C328.167 286.972 328.851 283.995 329.084 280.992"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M313.651 296.75C318.145 298.693 322.397 301.179 326.291 304.14"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M310.149 298.692C310.983 295.707 310.516 292.379 308.89 289.727"
        stroke="#9DD8E5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <mask
        id="mask0_7684_32396"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="358"
        height="336"
      >
        <path
          d="M296.217 335.602H64.1661C38.8366 309.322 20.5857 274.235 11.6395 235.411C-14.8657 120.39 27.8727 87.4456 66.4256 92.9669C145.116 104.251 65.3751 52.4831 109.714 17.0619C148.576 -13.9889 224.206 -0.694526 243.799 41.0569C271.438 99.9477 352.571 71.3488 360.308 163.592C364.727 216.261 348.46 288.18 296.209 335.602H296.217Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_7684_32396)">
        <path
          d="M214.476 246.727H150.452C145.492 246.727 141.472 250.748 141.472 255.709V288.695C141.472 293.656 145.492 297.677 150.452 297.677H214.476C219.435 297.677 223.455 293.656 223.455 288.695V255.709C223.455 250.748 219.435 246.727 214.476 246.727Z"
          fill="#01566D"
        />
        <path
          d="M218.945 258.79V285.629C218.945 290.741 214.801 294.886 209.69 294.886H155.229C152.978 294.886 150.919 294.086 149.31 292.751C147.267 291.041 145.966 288.489 145.966 285.629V258.79C145.966 253.677 150.118 249.523 155.229 249.523H209.69C213.892 249.523 217.436 252.334 218.562 256.162C218.812 256.996 218.937 257.872 218.937 258.781L218.945 258.79Z"
          fill="#F94B8A"
        />
        <path
          d="M218.945 258.786V285.625C218.945 290.738 214.801 294.883 209.69 294.883H155.229C152.978 294.883 150.919 294.082 149.31 292.748C149.06 291.914 148.926 291.03 148.926 290.112V263.273C148.926 258.161 153.078 254.016 158.189 254.016H212.65C214.901 254.016 216.961 254.825 218.57 256.167C218.82 257.001 218.945 257.877 218.945 258.786Z"
          fill="#F7376D"
        />
        <path
          d="M319.704 280.219H45.6318V380.002H319.704V280.219Z"
          fill="#01818E"
        />
        <path
          d="M319.704 284.125H45.6318V292.265H319.704V284.125Z"
          fill="#01566D"
        />
        <path
          d="M327.225 276.633H37.6943V284.131H327.225V276.633Z"
          fill="#00657C"
        />
        <path
          d="M275.848 273.078H208.373V276.648H275.848V273.078Z"
          fill="#75B3C8"
        />
        <path
          d="M309.591 273.078H242.115V276.648H309.591V273.078Z"
          fill="#448399"
        />
        <path
          d="M252.853 234.352H322.847L307.656 274.86H240.172L252.853 234.352Z"
          fill="#75B3C8"
        />
        <path
          d="M255.463 234.352H325.457L310.258 274.86H242.782L255.463 234.352Z"
          fill="#4A94A0"
        />
        <path
          d="M289.831 254.602C289.831 256.787 287.279 258.564 284.128 258.564C280.976 258.564 278.425 256.787 278.425 254.602C278.425 252.417 280.976 250.641 284.128 250.641C287.279 250.641 289.831 252.417 289.831 254.602Z"
          fill="#D3E8F9"
        />
        <path
          d="M74.6132 225.719H61.4565V276.636H74.6132V225.719Z"
          fill="#36A993"
        />
        <path
          d="M72.654 231.906H63.4326V255.626H72.654V231.906Z"
          fill="white"
        />
        <path
          d="M71.0036 234.352H65.1006V235.294H71.0036V234.352Z"
          fill="#063C50"
        />
        <path
          d="M70.9865 237.734H65.0835V238.677H70.9865V237.734Z"
          fill="#063C50"
        />
        <path
          d="M70.9865 241.125H65.0835V242.067H70.9865V241.125Z"
          fill="#063C50"
        />
        <path
          d="M71.0114 244.508H65.1084V245.45H71.0114V244.508Z"
          fill="#063C50"
        />
        <path
          d="M70.9948 247.898H65.0918V248.841H70.9948V247.898Z"
          fill="#063C50"
        />
        <path
          d="M70.9948 251.281H65.0918V252.224H70.9948V251.281Z"
          fill="#063C50"
        />
        <path
          d="M68.0348 273.686C70.3786 273.686 72.2787 271.785 72.2787 269.441C72.2787 267.096 70.3786 265.195 68.0348 265.195C65.691 265.195 63.791 267.096 63.791 269.441C63.791 271.785 65.691 273.686 68.0348 273.686Z"
          fill="white"
        />
        <path
          d="M68.0348 272.451C69.6971 272.451 71.0446 271.103 71.0446 269.441C71.0446 267.778 69.6971 266.43 68.0348 266.43C66.3725 266.43 65.0249 267.778 65.0249 269.441C65.0249 271.103 66.3725 272.451 68.0348 272.451Z"
          fill="#063C50"
        />
        <path
          d="M90.413 225.719H77.2563V276.636H90.413V225.719Z"
          fill="#F7376D"
        />
        <path
          d="M88.4455 231.906H79.2241V255.626H88.4455V231.906Z"
          fill="white"
        />
        <path
          d="M86.8034 234.352H80.9004V235.294H86.8034V234.352Z"
          fill="#063C50"
        />
        <path
          d="M86.7863 237.734H80.8833V238.677H86.7863V237.734Z"
          fill="#063C50"
        />
        <path
          d="M86.7863 241.125H80.8833V242.067H86.7863V241.125Z"
          fill="#063C50"
        />
        <path
          d="M86.8112 244.508H80.9082V245.45H86.8112V244.508Z"
          fill="#063C50"
        />
        <path
          d="M86.7946 247.898H80.8916V248.841H86.7946V247.898Z"
          fill="#063C50"
        />
        <path
          d="M86.7946 251.281H80.8916V252.224H86.7946V251.281Z"
          fill="#063C50"
        />
        <path
          d="M83.8346 273.686C86.1784 273.686 88.0785 271.785 88.0785 269.441C88.0785 267.096 86.1784 265.195 83.8346 265.195C81.4908 265.195 79.5908 267.096 79.5908 269.441C79.5908 271.785 81.4908 273.686 83.8346 273.686Z"
          fill="white"
        />
        <path
          d="M83.8346 272.451C85.4969 272.451 86.8444 271.103 86.8444 269.441C86.8444 267.778 85.4969 266.43 83.8346 266.43C82.1723 266.43 80.8247 267.778 80.8247 269.441C80.8247 271.103 82.1723 272.451 83.8346 272.451Z"
          fill="#063C50"
        />
        <path
          d="M106.171 225.719H93.0142V276.636H106.171V225.719Z"
          fill="#FCB211"
        />
        <path
          d="M104.212 231.906H94.9902V255.626H104.212V231.906Z"
          fill="white"
        />
        <path
          d="M102.561 234.352H96.6582V235.294H102.561V234.352Z"
          fill="#063C50"
        />
        <path
          d="M102.544 237.734H96.6411V238.677H102.544V237.734Z"
          fill="#063C50"
        />
        <path
          d="M102.544 241.125H96.6411V242.067H102.544V241.125Z"
          fill="#063C50"
        />
        <path
          d="M102.569 244.508H96.666V245.45H102.569V244.508Z"
          fill="#063C50"
        />
        <path
          d="M102.552 247.898H96.6494V248.841H102.552V247.898Z"
          fill="#063C50"
        />
        <path
          d="M102.552 251.281H96.6494V252.224H102.552V251.281Z"
          fill="#063C50"
        />
        <path
          d="M99.6008 273.686C101.945 273.686 103.845 271.785 103.845 269.441C103.845 267.096 101.945 265.195 99.6008 265.195C97.257 265.195 95.3569 267.096 95.3569 269.441C95.3569 271.785 97.257 273.686 99.6008 273.686Z"
          fill="white"
        />
        <path
          d="M99.6007 272.451C101.263 272.451 102.611 271.103 102.611 269.441C102.611 267.778 101.263 266.43 99.6007 266.43C97.9384 266.43 96.5908 267.778 96.5908 269.441C96.5908 271.103 97.9384 272.451 99.6007 272.451Z"
          fill="#063C50"
        />
      </g>
      <path
        d="M228.966 74.5373C228.966 74.5373 233.277 88.2821 219.278 97.7233C219.278 97.7233 230.433 103.169 237.229 101.051C244.024 98.9243 256.613 87.9568 257.339 66.0469L228.966 74.5373Z"
        fill="white"
      />
      <path
        d="M242.59 100.657C246.934 98.8551 250.152 97.0119 252.903 93.534C255.113 90.74 257.339 86.1612 257.331 82.1328C254.563 89.7225 249.668 96.3113 242.59 100.657Z"
        fill="white"
      />
      <path
        d="M232.868 103.42C230.676 103.979 228.458 104.529 226.223 104.413C224.397 104.313 221.704 103.787 220.445 101.752C221.804 101.168 224.756 103.053 226.373 103.337C228.524 103.72 230.709 103.754 232.868 103.429V103.42Z"
        fill="white"
      />
      <path
        d="M273.147 126.254C272.713 125.837 286.204 110.883 286.204 110.883C286.204 110.883 299.644 122.451 312.734 118.673L308.006 142.217C308.006 142.217 290.231 142.634 273.155 126.254H273.147Z"
        fill="white"
      />
      <path
        d="M304.822 143.566C304.822 143.566 289.33 142.649 275.757 131.281C275.757 131.281 284.745 144.851 304.822 143.566Z"
        fill="white"
      />
      <path
        d="M313.617 120.734C313.617 120.734 311.6 133.845 310.132 139.35C310.132 139.35 314.259 133.754 313.617 120.734Z"
        fill="white"
      />
      <path
        d="M142.081 37.1509C142.081 37.1509 156.096 35.4161 159.873 26.9257C163.066 19.7614 164.275 15.3411 171.596 11.6797L195.466 18.8357C195.466 18.8357 184.669 24.2985 180.784 36.2335C177.524 46.2418 164.525 48.9608 164.525 48.9608L142.064 37.1509H142.081Z"
        fill="white"
      />
      <path
        d="M189.897 25.8365C189.897 25.8365 183.435 32.0333 181.859 39.3644C180.283 46.7039 171.404 49.9983 171.404 49.9983C171.404 49.9983 180.792 49.3561 183.243 40.1567C185.686 30.9574 189.163 26.6538 189.905 25.8281L189.897 25.8365Z"
        fill="white"
      />
      <path
        d="M142.848 40.3906L159.448 48.9644C159.448 48.9644 148.692 46.3789 142.848 40.3906Z"
        fill="white"
      />
      <path
        d="M136.878 101.418C136.878 101.418 130.625 87.4732 144.199 75.7717C144.199 75.7717 131.759 71.4181 124.864 74.504C117.969 77.5899 106.071 90.7259 108.038 113.895L136.878 101.41V101.418Z"
        fill="white"
      />
      <path
        d="M121.804 74.5938C121.804 74.5938 106.721 83.5345 106.437 103.151C106.437 103.151 102.269 84.1851 121.804 74.5938Z"
        fill="white"
      />
      <path
        d="M134.577 104.398L113.941 112.989C113.941 112.989 125.856 110.912 134.577 104.398Z"
        fill="white"
      />
      <path
        d="M41.1543 142.091C40.5289 142.041 41.5795 120.848 41.5795 120.848C41.5795 120.848 60.2473 121.341 68.4264 109.539L80.2408 131.916C80.2408 131.916 66.0002 144.101 41.1543 142.1V142.091Z"
        fill="white"
      />
      <path
        d="M45.1812 143.687C45.1812 143.687 60.7224 145.631 77.6727 135.664C77.6727 135.664 63.1236 148.458 45.1812 143.687Z"
        fill="white"
      />
      <path
        d="M44.1475 118.829C44.1475 118.829 55.5032 119.363 64.6162 111.648C64.6162 111.648 53.6856 117.97 44.1475 118.829Z"
        fill="white"
      />
      <path
        d="M247.909 202.297C247.909 202.297 243.39 212.606 225.006 216.968C207.264 221.171 182.976 217.301 181.3 217.026C179.624 217.301 155.337 221.221 137.595 217.051C119.202 212.722 114.667 202.431 114.667 202.431L123.538 181.413L154.77 183.832L157.805 180.245L181.267 186.442L204.721 180.195L207.764 183.773L239.18 181.271L247.901 202.297H247.909Z"
        fill="#052C39"
      />
      <path
        d="M184.969 221.292C184.969 221.292 190.964 220.524 194.007 219.523"
        stroke="#AE3838"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M141.88 228.219C148.55 227.193 152.903 226.684 158.414 225.884C163.925 225.083 172.046 224.057 171.679 217.16C171.312 210.271 161.299 210.421 158.981 210.646C156.663 210.871 144.257 211.388 138.379 210.596C136.936 210.404 135.861 210.279 134.927 210.237C132.042 210.104 130.516 210.688 123.946 212.064C115.25 213.882 115.325 218.094 115.325 218.094C115.325 218.094 115.117 220.854 118.543 223.056C119.127 223.423 119.811 223.782 120.62 224.107C126.206 226.351 135.202 229.245 141.872 228.219H141.88Z"
        fill="#F2F9F9"
      />
      <path
        d="M169.87 217.163C169.87 217.163 170.887 219.557 165.084 221.592C159.281 223.627 154.387 225.337 151.419 223.894C148.442 222.443 147.275 217.355 148.834 214.178C150.393 211 156.063 211.809 158.722 212.535C161.382 213.26 166.801 213.352 168.636 214.795C170.478 216.246 169.87 217.163 169.87 217.163Z"
        fill="#FFA78F"
      />
      <path
        d="M118.552 223.049C115.251 220.113 115.751 216.702 119.461 214.817C123.138 212.957 134.669 210.288 134.936 210.229C132.051 210.096 130.525 210.68 123.955 212.056C115.259 213.874 115.334 218.086 115.334 218.086C115.334 218.086 115.126 220.847 118.552 223.049Z"
        fill="#B2C9D8"
      />
      <path
        d="M145.065 221.397C144.915 221.397 144.773 221.322 144.682 221.188C144.598 221.063 142.722 218.152 144.523 215.25C144.657 215.033 144.94 214.967 145.157 215.1C145.374 215.233 145.44 215.517 145.307 215.734C143.823 218.127 145.382 220.58 145.449 220.68C145.59 220.888 145.532 221.18 145.315 221.313C145.24 221.363 145.149 221.389 145.065 221.389V221.397Z"
        fill="#212473"
      />
      <path
        d="M143.131 221.623C142.981 221.623 142.839 221.548 142.748 221.415C142.664 221.29 140.788 218.379 142.589 215.477C142.723 215.26 143.006 215.193 143.223 215.327C143.44 215.46 143.506 215.744 143.373 215.96C141.889 218.354 143.448 220.806 143.515 220.906C143.656 221.115 143.598 221.407 143.381 221.54C143.306 221.59 143.214 221.615 143.131 221.615V221.623Z"
        fill="#212473"
      />
      <path
        d="M141.197 221.623C141.046 221.623 140.905 221.548 140.813 221.415C140.73 221.29 138.854 218.379 140.655 215.477C140.788 215.26 141.071 215.193 141.288 215.327C141.505 215.46 141.572 215.744 141.438 215.96C139.954 218.354 141.513 220.806 141.58 220.906C141.722 221.115 141.663 221.407 141.447 221.54C141.372 221.59 141.28 221.615 141.197 221.615V221.623Z"
        fill="#212473"
      />
      <path
        d="M139.262 221.772C139.112 221.772 138.971 221.697 138.879 221.563C138.796 221.438 136.92 218.528 138.72 215.625C138.854 215.408 139.137 215.342 139.354 215.475C139.571 215.608 139.638 215.892 139.504 216.109C138.012 218.519 139.629 221.03 139.646 221.055C139.788 221.263 139.729 221.555 139.513 221.688C139.438 221.739 139.346 221.764 139.262 221.764V221.772Z"
        fill="#212473"
      />
      <path
        d="M166.026 223.202C162.533 223.427 159.69 223.552 158.006 223.61C156.93 223.644 156.338 223.661 156.338 223.661C156.338 223.661 153.02 221.3 152.428 212.701C152.428 212.701 154.746 211.892 158.372 210.633C159.156 210.366 159.998 210.074 160.899 209.766L164.3 210.174C164.3 210.174 167.16 216.571 167.627 218.548C167.886 219.649 166.943 221.626 166.035 223.193L166.026 223.202Z"
        fill="#FFA78F"
      />
      <path
        d="M166.026 223.201L158.005 223.61L158.372 210.641C159.156 210.374 159.998 210.082 160.899 209.773L164.3 210.182C164.3 210.182 167.16 216.579 167.627 218.556C167.885 219.657 166.943 221.633 166.034 223.201H166.026Z"
        fill="#F9867D"
      />
      <path
        d="M235.82 210.333C230.426 212.927 221.071 215.287 210.799 217.306C188.68 221.651 162.325 224.412 162.325 224.412L159.04 208.015L185.836 198.857L234.153 182.343C234.153 182.343 245.475 177.281 249.302 188.79C253.129 200.3 246.217 205.346 235.829 210.333H235.82Z"
        fill="#043649"
      />
      <path
        d="M219.837 228.074C213.159 227.065 208.806 226.564 203.295 225.772C197.784 224.98 189.663 223.97 190.013 217.081C190.372 210.184 200.377 210.326 202.695 210.534C205.021 210.751 217.419 211.243 223.297 210.442C224.731 210.242 225.815 210.125 226.749 210.075C229.634 209.934 231.159 210.517 237.729 211.877C246.434 213.678 246.367 217.89 246.367 217.89C246.367 217.89 246.584 220.651 243.157 222.853C242.573 223.228 241.89 223.587 241.081 223.912C235.503 226.164 226.507 229.075 219.837 228.074Z"
        fill="#F2F9F9"
      />
      <path
        d="M191.831 217.079C191.831 217.079 190.814 219.472 196.625 221.499C202.428 223.526 207.33 225.227 210.298 223.768C213.267 222.316 214.426 217.221 212.866 214.043C211.299 210.865 205.638 211.691 202.978 212.417C200.318 213.142 194.907 213.251 193.065 214.702C191.23 216.153 191.831 217.07 191.831 217.07V217.079Z"
        fill="#FFA78F"
      />
      <path
        d="M243.165 222.861C246.467 219.916 245.958 216.505 242.24 214.637C238.563 212.785 227.015 210.142 226.757 210.083C229.642 209.941 231.167 210.525 237.737 211.885C246.442 213.686 246.375 217.898 246.375 217.898C246.375 217.898 246.592 220.659 243.165 222.861Z"
        fill="#B2C9D8"
      />
      <path
        d="M216.644 221.256C216.794 221.256 216.936 221.181 217.027 221.048C217.111 220.923 218.978 218.012 217.169 215.109C217.036 214.893 216.752 214.826 216.535 214.959C216.319 215.093 216.252 215.376 216.385 215.593C217.878 217.987 216.319 220.439 216.252 220.539C216.11 220.747 216.177 221.039 216.385 221.173C216.46 221.223 216.552 221.248 216.635 221.248L216.644 221.256Z"
        fill="#212473"
      />
      <path
        d="M218.578 221.475C218.728 221.475 218.87 221.4 218.961 221.266C219.045 221.141 220.912 218.231 219.111 215.328C218.978 215.111 218.695 215.045 218.478 215.178C218.261 215.312 218.194 215.595 218.328 215.812C219.82 218.206 218.261 220.658 218.194 220.758C218.053 220.966 218.119 221.258 218.328 221.392C218.403 221.442 218.494 221.467 218.578 221.467V221.475Z"
        fill="#212473"
      />
      <path
        d="M220.512 221.475C220.663 221.475 220.804 221.4 220.896 221.266C220.979 221.141 222.847 218.231 221.038 215.328C220.904 215.111 220.621 215.045 220.404 215.178C220.187 215.312 220.121 215.595 220.254 215.812C221.746 218.206 220.187 220.658 220.121 220.758C219.979 220.966 220.046 221.258 220.254 221.392C220.329 221.442 220.421 221.467 220.504 221.467L220.512 221.475Z"
        fill="#212473"
      />
      <path
        d="M222.447 221.623C222.597 221.623 222.738 221.548 222.83 221.415C222.914 221.29 224.781 218.379 222.972 215.477C222.839 215.26 222.555 215.193 222.338 215.327C222.122 215.46 222.055 215.744 222.188 215.96C223.689 218.362 222.071 220.881 222.055 220.906C221.913 221.115 221.971 221.407 222.188 221.54C222.263 221.59 222.355 221.615 222.438 221.615L222.447 221.623Z"
        fill="#212473"
      />
      <path
        d="M195.683 223.116C199.176 223.341 202.019 223.458 203.704 223.508C204.779 223.541 205.371 223.558 205.371 223.558C205.371 223.558 208.681 221.189 209.256 212.59C209.256 212.59 206.939 211.79 203.303 210.539C202.52 210.272 201.678 209.988 200.777 209.68L197.375 210.097C197.375 210.097 194.532 216.502 194.065 218.47C193.807 219.571 194.749 221.548 195.666 223.116H195.683Z"
        fill="#FFA78F"
      />
      <path
        d="M195.683 223.116L203.704 223.508L203.312 210.539C202.528 210.272 201.686 209.988 200.785 209.68L197.384 210.097C197.384 210.097 194.541 216.502 194.074 218.47C193.815 219.571 194.757 221.548 195.674 223.116H195.683Z"
        fill="#F9867D"
      />
      <path
        d="M199.393 224.324L202.636 207.91L127.481 182.397C127.481 182.397 116.151 177.351 112.349 188.869C108.547 200.387 115.475 205.425 125.864 210.387C142.898 218.519 199.393 224.316 199.393 224.316V224.324Z"
        fill="#063C50"
      />
      <path
        d="M265.819 162.501L263.251 171.925C263.251 171.925 256.106 174.46 242.715 176.729C242.59 176.746 242.457 176.771 242.315 176.787C235.112 177.98 227.424 178.089 221.78 177.93L224.915 163.551C228.917 163.143 234.403 163.101 240.181 163.134C249.702 163.184 260.024 163.426 265.819 162.492V162.501Z"
        fill="#FFA78F"
      />
      <path
        d="M240.181 163.142L242.715 176.729C242.59 176.745 242.457 176.77 242.315 176.787C235.112 177.98 227.424 178.088 221.78 177.93L224.915 163.551C228.917 163.142 234.403 163.101 240.181 163.134V163.142Z"
        fill="#F9867D"
      />
      <path
        d="M261.191 172.591C261.191 172.591 263.609 172.099 265.185 172.34C266.761 172.582 272.514 172.024 277.225 168.737C281.944 165.46 285.204 164.843 286.596 163.566C287.988 162.29 285.054 161.632 281.352 163.591C278.567 165.068 278.35 164.751 278.35 164.751C278.35 164.751 282.836 161.515 285.654 160.147C288.464 158.779 289.189 158.504 289.464 157.87C289.739 157.236 287.713 155.893 285.037 157.495C282.36 159.088 279.392 160.439 278.258 161.123C278.258 161.123 281.16 159.121 281.952 158.412C282.744 157.703 286.971 154.017 287.63 153.441C288.289 152.874 288.589 152.365 288.222 151.857C287.93 151.44 286.929 151.181 284.687 153.024C282.027 155.218 276.391 158.604 276.391 158.604C276.391 158.604 279.167 156.177 278.8 153.692C278.434 151.206 272.097 149.138 271.463 149.23C270.83 149.321 270.921 150.681 272.047 151.556C273.173 152.432 275.324 153.483 275.415 154.551C275.507 155.61 273.089 158.095 272.064 158.404C271.038 158.712 271.763 153.024 271.597 151.957C271.43 150.889 269.988 149.33 269.137 149.571C268.287 149.813 268.87 152.207 268.812 153.725C268.754 155.243 267.728 157.728 266.436 159.33C265.135 160.939 264.293 162.274 263.843 163.758C263.393 165.243 261.425 165.401 261.425 165.401L261.2 172.607L261.191 172.591Z"
        fill="#FFA78F"
      />
      <path
        d="M272.172 160.719C272.172 160.719 270.721 164.063 268.287 165.439"
        stroke="#AE3838"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M273.081 160.297C273.081 160.297 273.956 164.509 275.348 166.21"
        stroke="#AE3838"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M235.478 162.532L236.012 178.412C236.012 178.412 221.78 179.454 217.519 178.003C215.66 177.369 213.209 171.898 211.441 167.411C209.665 162.924 207.556 156.394 207.556 156.394L202.537 117.828C202.537 117.828 208.023 118.395 212.592 123.133C216.552 127.236 223.581 158.47 226.449 161.398C228.158 163.141 230.001 161.781 235.478 162.54V162.532Z"
        fill="#F2F9F9"
      />
      <path
        d="M232.235 162.05C232.235 162.05 235.278 160.424 238.246 161.975L239.78 177.888C239.78 177.888 235.82 179.732 233.836 178.773L232.243 162.05H232.235Z"
        fill="#C7D7E2"
      />
      <path
        d="M99.1172 162.672L101.71 172.089C101.71 172.089 108.864 174.607 122.254 176.851C122.379 176.868 122.512 176.893 122.654 176.909C129.858 178.094 137.545 178.177 143.19 178.01L140.03 163.64C136.028 163.24 130.541 163.206 124.764 163.256C115.242 163.323 104.92 163.59 99.1255 162.664L99.1172 162.672Z"
        fill="#FFA78F"
      />
      <path
        d="M124.755 163.261L122.246 176.847C122.371 176.864 122.504 176.889 122.646 176.905C129.849 178.09 137.537 178.173 143.181 178.006L140.021 163.636C136.019 163.236 130.533 163.202 124.755 163.252V163.261Z"
        fill="#F9867D"
      />
      <path
        d="M103.753 172.761C103.753 172.761 101.335 172.277 99.7592 172.519C98.1834 172.761 92.4305 172.21 87.7114 168.941C82.9924 165.672 79.724 165.063 78.3317 163.787C76.9393 162.511 79.8658 161.843 83.576 163.795C86.3607 165.263 86.5775 164.954 86.5775 164.954C86.5775 164.954 82.0836 161.727 79.2655 160.367C76.4474 158.999 75.722 158.733 75.4552 158.099C75.1801 157.465 77.2061 156.122 79.8825 157.707C82.5588 159.3 85.5353 160.642 86.6692 161.326C86.6692 161.326 83.7678 159.325 82.9674 158.624C82.1753 157.924 77.9398 154.237 77.2811 153.67C76.6225 153.103 76.3223 152.602 76.6808 152.085C76.9727 151.668 77.9732 151.41 80.216 153.245C82.884 155.43 88.5285 158.808 88.5285 158.808C88.5285 158.808 85.7438 156.381 86.1106 153.904C86.4775 151.418 92.8057 149.333 93.4393 149.425C94.073 149.517 93.9813 150.876 92.8641 151.76C91.7468 152.636 89.5957 153.695 89.504 154.754C89.4123 155.813 91.8302 158.299 92.8641 158.599C93.8896 158.899 93.1559 153.22 93.3226 152.152C93.4894 151.084 94.9318 149.517 95.7739 149.758C96.6243 150 96.049 152.394 96.1074 153.904C96.1657 155.421 97.1996 157.899 98.5002 159.508C99.8009 161.118 100.651 162.444 101.102 163.929C101.552 165.413 103.519 165.563 103.519 165.563L103.761 172.769L103.753 172.761Z"
        fill="#FFA78F"
      />
      <path
        d="M92.7559 160.906C92.7559 160.906 94.2149 164.242 96.6495 165.619"
        stroke="#AE3838"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M91.8386 160.484C91.8386 160.484 90.9715 164.705 89.5791 166.398"
        stroke="#AE3838"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M129.458 162.644L128.949 178.524C128.949 178.524 143.181 179.541 147.442 178.073C149.301 177.431 151.736 171.96 153.495 167.464C155.263 162.969 157.355 156.438 157.355 156.438L162.299 117.865C162.299 117.865 157.364 117.164 152.811 121.901C148.859 126.013 141.339 158.54 138.479 161.476C136.778 163.227 134.927 161.868 129.458 162.635V162.644Z"
        fill="#F2F9F9"
      />
      <path
        d="M132.701 162.153C132.701 162.153 129.658 160.535 126.69 162.087L125.189 178C125.189 178 129.158 179.835 131.142 178.876L132.701 162.153Z"
        fill="#C7D7E2"
      />
      <path
        d="M192.081 120.366L181.117 131.134L170.12 120.383C171.412 118.507 172.263 116.388 172.813 114.353C174.039 109.816 173.789 105.704 173.789 105.704L188.379 105.688C188.379 105.688 188.246 108.014 188.713 111.109C189.13 113.953 190.064 117.447 192.081 120.358V120.366Z"
        fill="#FFA78F"
      />
      <path
        d="M188.713 111.116C185.703 112.626 180.317 114.569 172.805 114.361C174.03 109.824 173.78 105.712 173.78 105.712L188.371 105.695C188.371 105.695 188.238 108.022 188.704 111.116H188.713Z"
        fill="#F9867D"
      />
      <path
        d="M203.695 91.9929C204.688 93.9779 203.254 96.7135 200.486 98.098C197.717 99.4825 194.666 98.9988 193.674 97.0221C192.682 95.0371 194.116 92.3015 196.884 90.917C199.652 89.5325 202.703 90.0079 203.695 91.9929Z"
        fill="#F9867D"
      />
      <path
        d="M158.389 92.3337C157.422 94.3354 158.906 97.046 161.691 98.3888C164.475 99.7316 167.519 99.2061 168.486 97.2045C169.453 95.2028 167.969 92.4922 165.184 91.1494C162.399 89.8066 159.356 90.3321 158.389 92.3337Z"
        fill="#F9867D"
      />
      <path
        d="M198.309 90.5102C198.393 101.169 190.747 110.927 181.417 111.002C172.088 111.077 164.609 101.428 164.526 90.7688C164.442 80.1099 171.938 71.411 181.267 71.3442C190.597 71.2692 198.226 79.8513 198.301 90.5102H198.309Z"
        fill="#FFA78F"
      />
      <path
        d="M166.36 88.8779C166.36 88.8779 167.252 86.3174 167.952 85.0497L171.913 84.4742C171.913 84.4742 171.888 86.0839 174.422 86.1673C176.957 86.2507 188.413 85.1331 193.574 83.6402C193.574 83.6402 196.05 86.0172 196.367 87.852C196.367 87.852 198.476 84.1239 196.367 81.6385C194.249 79.1531 189.346 74.1406 187.887 74.1406C186.428 74.1406 172.78 74.1573 172.78 74.1573C172.78 74.1573 167.777 80.3458 167.31 80.4626C166.843 80.5793 166.36 81.8887 166.36 81.8887L164.709 87.8854L166.368 88.8696L166.36 88.8779Z"
        fill="#F9867D"
      />
      <path
        d="M165.851 98.014C165.851 98.014 165.159 89.3401 168.302 82.0507L167.635 72.4844C167.635 72.4844 156.855 78.0557 165.851 98.014Z"
        fill="#072D38"
      />
      <path
        d="M197.059 97.9779C197.059 97.9779 197.734 89.304 194.574 82.0229C194.574 82.0229 186.12 84.133 178.099 84.6335C170.037 85.1339 175.756 82.3649 176.44 82.0229C175.873 82.2315 170.846 83.9496 166.335 83.6576H166.327C166.277 83.6576 166.218 83.6576 166.16 83.6493C165.451 83.5993 164.767 83.4908 164.109 83.3324C163.784 83.249 163.484 83.1489 163.217 83.0321H163.208C162.508 82.7235 161.899 82.3149 161.399 81.8812C159.665 80.4049 159.031 78.5534 159.031 78.5534C160.632 76.8019 161.941 75.0672 162.7 74.0079C162.716 73.9829 162.733 73.9579 162.75 73.9329C163.025 73.5492 163.217 73.2657 163.317 73.1072C163.375 73.0321 163.4 72.9821 163.4 72.9821C164.859 70.9888 167.26 68.4783 171.021 66.4683C178.391 62.5234 191.881 64.5751 195.216 72.4483C195.216 72.4483 206.005 78.0029 197.051 97.9696L197.059 97.9779Z"
        fill="#072D38"
      />
      <path
        d="M195.224 72.4488C195.224 72.4488 188.171 66.1186 180.667 66.227C173.163 66.3354 167.177 70.8392 164.684 74.1753C162.199 77.503 160.457 79.1794 160.457 79.1794C160.473 80.0718 161.39 81.8733 161.39 81.8733C159.656 80.3971 159.022 78.5456 159.022 78.5456C160.623 76.7941 161.932 75.0593 162.691 74.0001C162.708 73.9751 162.724 73.9501 162.741 73.9251C163.016 73.5414 163.208 73.2578 163.308 73.0994C163.366 73.0243 163.391 72.9743 163.391 72.9743C164.85 70.9809 167.252 68.4705 171.012 66.4605C178.382 62.5156 191.872 64.5673 195.208 72.4405L195.224 72.4488Z"
        fill="#0F5C60"
      />
      <path
        d="M180.392 93.0781C180.392 93.0781 179.6 96.506 180.659 98.8079"
        stroke="#C94357"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M180.384 101.713C180.384 101.713 185.153 102.347 187.212 98.7109"
        stroke="#C94357"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.936 87.3779C186.729 86.9609 189.697 87.8116 191.223 89.5881"
        stroke="#072D38"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185.003 92.7812C186.279 93.4235 187.804 93.5319 189.155 93.0815"
        stroke="#072D38"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M176.532 87.385C174.739 86.968 171.771 87.8271 170.253 89.6119"
        stroke="#072D38"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M176.473 92.7891C175.198 93.4313 173.672 93.548 172.321 93.0976"
        stroke="#072D38"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.873 183.11C210.015 184.795 202.253 189.365 181.201 191.709H181.184C180.909 191.676 180.634 191.651 180.35 191.617C180.058 191.584 179.775 191.55 179.483 191.525C159.706 189.157 152.386 184.811 153.478 183.168C154.145 182.176 154.445 180.917 154.57 180.049C154.57 179.941 154.562 179.832 154.562 179.724C154.487 177.722 154.345 175.47 154.137 173.035C153.211 161.467 151.219 145.971 151.41 136.029C151.669 122.101 153.061 119.307 159.615 117.864C162.691 117.188 167.61 116.863 171.971 116.696C171.971 116.696 174.264 123.886 181.075 123.877C187.887 123.877 190.163 116.68 190.163 116.68C191.206 116.721 192.273 116.763 193.348 116.821C196.775 117.005 200.177 117.314 202.528 117.822C209.081 119.249 210.482 122.042 210.774 135.971C210.807 137.981 209.306 155.904 208.389 168.723C208.056 173.36 207.797 177.33 207.714 179.64C207.822 180.5 208.106 181.976 208.865 183.11H208.873Z"
        fill="#F2F9F9"
      />
      <path
        d="M153.495 166.547C152.411 155.621 151.652 144.671 151.21 133.703"
        stroke="#C7D7E2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M147.725 144.82C148.967 146.814 150.385 148.707 151.952 150.458"
        stroke="#C7D7E2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.848 159.998C208.848 150.773 209.214 141.357 209.214 132.133"
        stroke="#C7D7E2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M208.956 149.716C210.632 148.273 212.083 146.572 213.242 144.695"
        stroke="#C7D7E2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M181.201 191.712H181.184C160.123 189.41 152.353 184.856 153.487 183.171C154.154 182.179 154.454 180.92 154.579 180.052C154.579 179.944 154.57 179.835 154.57 179.727C157.705 182.538 164.867 186.307 180.342 185.081C204.229 183.188 208.389 168.734 208.389 168.734C208.056 173.372 207.798 177.342 207.714 179.652C207.823 180.511 208.106 181.987 208.865 183.121C210.007 184.806 202.245 189.377 181.192 191.72L181.201 191.712Z"
        fill="#D3E3EA"
      />
      <path
        d="M178.891 127.141C178.891 127.141 177.524 140.235 182.66 146.29C187.796 152.353 192.223 157.758 192.123 171.386L199.385 175.022C199.385 175.022 198.635 156.649 190.931 149.81C183.227 142.97 182.235 137.841 181.734 136.207C181.234 134.572 180.767 128.158 180.767 128.158L178.899 127.141H178.891Z"
        fill="#C1D7E5"
      />
      <path
        d="M180.291 127.141L180.358 191.619C180.066 191.586 179.783 191.553 179.491 191.528L179.424 127.149H180.291V127.141Z"
        fill="#AEC6D6"
      />
      <path
        d="M183.576 148.441C183.576 148.95 183.168 149.358 182.659 149.358C182.151 149.358 181.742 148.95 181.742 148.441C181.742 147.932 182.151 147.523 182.659 147.523C183.168 147.523 183.576 147.932 183.576 148.441Z"
        fill="#AEC6D6"
      />
      <path
        d="M183.585 159.206C183.585 159.715 183.176 160.124 182.668 160.124C182.159 160.124 181.75 159.715 181.75 159.206C181.75 158.698 182.159 158.289 182.668 158.289C183.176 158.289 183.585 158.698 183.585 159.206Z"
        fill="#AEC6D6"
      />
      <path
        d="M183.593 169.675C183.593 170.184 183.185 170.593 182.676 170.593C182.167 170.593 181.759 170.184 181.759 169.675C181.759 169.166 182.167 168.758 182.676 168.758C183.185 168.758 183.593 169.166 183.593 169.675Z"
        fill="#AEC6D6"
      />
      <path
        d="M183.61 180.136C183.61 180.645 183.201 181.054 182.693 181.054C182.184 181.054 181.775 180.645 181.775 180.136C181.775 179.627 182.184 179.219 182.693 179.219C183.201 179.219 183.61 179.627 183.61 180.136Z"
        fill="#AEC6D6"
      />
      <path
        d="M201.777 160.088C199.901 153.674 188.646 146.977 185.611 141.906C183.418 138.245 182.651 132.165 182.392 129.07L185.728 125.726L181.083 123.883L176.439 125.734L179.866 129.154C179.591 145.91 188.137 148.695 191.505 155.309C195.007 162.19 194.907 171.514 194.907 171.514L200.277 175.709L203.537 170.338C203.537 170.338 203.653 166.493 201.777 160.08V160.088Z"
        fill="#0D939C"
      />
      <path
        d="M190.18 116.68C190.18 116.68 187.545 122.101 181.083 123.877C181.083 123.877 183.818 127.047 188.712 127.13C193.607 127.213 192.056 116.68 192.056 116.68H190.18Z"
        fill="#C7D7E2"
      />
      <path
        d="M171.979 116.695C171.979 116.695 174.63 122.108 181.084 123.876C181.084 123.876 178.357 127.054 173.463 127.146C168.569 127.237 170.095 116.704 170.095 116.704H171.971L171.979 116.695Z"
        fill="#C7D7E2"
      />
    </svg>
  )
}
